import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import Typed from 'typed.js';
import PageHeader from '../pages/PageHeader';
const PrivacyPolicy = () => {

    useEffect(() => {
        window.scrollTo(0, 0); // This will move the user to the top of the page
      }, []);
      

  return (
    <div>
     <Helmet>
  {/* Meta Title */}
  <title>Privacy Policy | Appnexts</title>

  {/* Meta Description */}
  <meta
    name="description"
    content="Read the Privacy Policy for Appnexts. Learn how we collect, use, and protect your personal information when you use our services."
  />

  {/* Meta Keywords */}
  <meta
    name="keywords"
    content="privacy policy, data protection, GDPR, personal information, data collection, Appnexts privacy, user data, online privacy"
  />

  {/* Canonical URL */}
  <link rel="canonical" href="https://www.appnexts.com/privacy-policy" />

  {/* Open Graph Tags */}
  <meta property="og:title" content="Privacy Policy | Appnexts" />
  <meta
    property="og:description"
    content="Understand how Appnexts collects, uses, and protects your personal data when you use our website and services."
  />
  <meta property="og:image" content="https://www.appnexts.com/seo_image/Privacy_Policy_seo.png" />
  <meta property="og:url" content="https://www.appnexts.com/privacy-policy" />
  <meta property="og:type" content="website" />

  {/* Twitter Card Tags */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Privacy Policy | Appnexts" />
  <meta
    name="twitter:description"
    content="Learn how Appnexts protects your data and respects your privacy when you interact with our services."
  />
  <meta name="twitter:image" content="https://www.appnexts.com/seo_image/Privacy_Policy_seo.png" />

  {/* Structured Data for SEO */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Privacy Policy",
      "url": "https://www.appnexts.com/privacy-policy",
      "description": "This Privacy Policy outlines how Appnexts collects, uses, and protects personal information from users.",
      "publisher": {
        "@type": "Organization",
        "name": "Appnexts",
        "url": "https://www.appnexts.com"
      },
      "mainEntity": {
        "@type": "PrivacyPolicy",
        "inLanguage": "en",
        "name": "Privacy Policy"
      }
    })}
  </script>
</Helmet>

      <PageHeader title="Our Privacy Policy" breadcrumb={[{ label: "Home", path: "/" },{ label: "Our Privacy Policy" }]}/>

<div>
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 ">
        <h1 className="text-lg font-bold leading-tight  mb-4 md:mb-0">
          Our Privacy Policy
        </h1>
        <p className="text-[15px] font-medium mb-8 mt-3">
        At appnexts, we value your privacy and are committed to protecting your personal information. This privacy policy outlines the types of information we collect, how we use that information, and how we protect your information.
        </p>
    </div>
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-12">
        <h1 className="text-lg font-bold leading-tight  mb-4 md:mb-0">
        Information We Collect:
        </h1>
        <p className="font-medium mt-3">
        We may collect the following information from our clients and website visitors:
        </p>
        <ul className="text-[15px] font-medium mb-8 mt-5 list-disc">
        <li className='mt-2'>Personal information such as name, email address, phone number, and company name </li>
        <li className='mt-2'>Business information such as business name, business type, and business address</li>
        <li className='mt-2'>Technical information such as IP address, browser type, and operating system</li>
        </ul>
    </div>

    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 ">
        <h1 className="text-lg font-bold leading-tight  mb-4 md:mb-0">
        How We Use Your Information:
        </h1>
        <p className="text-[15px] font-medium mb-8 mt-3">
        We use your information to provide our software development services and to communicate with you regarding your project. We may also use your information to send you marketing communications that may be of interest to you. You can opt-out of receiving these communications at any time.
        </p>
        <p className="text-[15px] font-medium mb-8 mt-3">
        We do not sell or share your information with third-party vendors for marketing purposes. We may share your information with our trusted third-party partners who assist us in providing our software development services.
        </p>
        <p className="text-[15px] font-medium mb-8 mt-3">
        We may disclose your information to comply with legal requirements, to protect our rights or property, or in the event of a merger or acquisition.
        </p>
    </div>
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 ">
        <h1 className="text-lg font-bold leading-tight  mb-4 md:mb-0">
        How We Protect Your Information:
        </h1>
        <p className="text-[15px] font-medium mb-8 mt-3">
        We take appropriate measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. We use industry-standard security measures such as encryption and secure servers to protect your information. We also limit access to your information to only those who need it to perform their duties.
        </p>
       
    </div>
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 ">
        <h1 className="text-lg font-bold leading-tight  mb-4 md:mb-0">
        Your Choices:
        </h1>
        <p className="text-[15px] font-medium mb-8 mt-3">
        You have the right to access and update your personal information. You can also opt-out of receiving marketing communications from us at any time. If you wish to access, update, or delete your information, please contact us at<Link to="mailto:info@appnexts.com" className='text-[#504e9a] font-semibold mx-1'> info@appnexts.com</Link>
        </p>
       
    </div>
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 ">
        <h1 className="text-lg font-bold leading-tight  mb-4 md:mb-0">
        Third-Party Websites:
        </h1>
        <p className="text-[15px] font-medium mb-8 mt-3">
        Our website may contain links to third-party websites that are not owned or operated by MetaViz. We are not responsible for the privacy practices or content of these websites. We recommend that you review the privacy policies of these websites before providing any personal information.
        </p>
       
    </div>
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 ">
        <h1 className="text-lg font-bold leading-tight  mb-4 md:mb-0">
        Updates to Privacy Policy:
        </h1>
        <p className="text-[15px] font-medium mb-8 mt-3">
        We may update this privacy policy from time to time. We will notify you of any changes by posting the updated policy on our website. We encourage you to review this policy periodically.
        </p>
       
    </div>
    <div className="max-w-6xl mx-auto px-4  sm:px-6 lg:px-8 mt-12 ">
        <h1 className="text-lg font-bold leading-tight  mb-4 md:mb-0">
        Contact Us:
        </h1>
        <p className="text-[15px] font-medium mb-8 mt-3">
        If you have any questions or concerns about our privacy policy, please contact us at
        <Link to="mailto:info@appnexts.com" className='text-[#504e9a] font-semibold mx-1'>info@appnexts.com</Link> We’re happy to answer any questions you may have and ensure that your personal information is protected.
        </p>
       
    </div>
    </div>
    </div>
  );
};

export default PrivacyPolicy;
